var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 24,
    width: 117,
    height: 12,
    rx: 2,
    fill: "#3C4148"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 26,
    width: 36,
    height: 8,
    rx: 1,
    fill: "white",
    fillOpacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 26,
    width: 37,
    height: 8,
    rx: 1,
    fill: "#D1D5DB",
    fillOpacity: 0.13
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 26,
    width: 36,
    height: 8,
    rx: 1,
    fill: "#D1D5DB",
    fillOpacity: 0.13
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 40,
    width: 198,
    height: 109,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.35
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 180,
    height: 95,
    rx: 4,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 54,
    width: 162,
    height: 82,
    rx: 4,
    fill: "#718095"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/tabs.df6e40edebb4c77d66fbf0ee8a8e89c1.svg";
export { ForwardRef as ReactComponent };